function syncTerminalNavigation() {
  const nextButton = document.getElementById('btn-next')
  if (!nextButton)
    return

  const page = document.body.dataset.page

  // PRESUPUESTO es una única pantalla: nunca existe un siguiente scroll.
  if (page === 'quote') {
    nextButton.classList.add('container-hidden')
    window.scrollTo({ left: 0, top: window.scrollY, behavior: 'auto' })
    document.documentElement.scrollLeft = 0
    document.body.scrollLeft = 0
    return
  }

  const fullpage = document.getElementById('fullpage')
  if (!fullpage)
    return

  const sections = Array.from(fullpage.children).filter(element =>
    element.classList.contains('section')
  )

  if (!sections.length)
    return

  const activeSection =
    sections.find(element => element.classList.contains('active')) ||
    document.querySelector('#fullpage > .section.active')

  const activeIndex = activeSection ? sections.indexOf(activeSection) : -1

  // En la última sección, abrir/cerrar Sidr no debe reactivar la flecha de bajar.
  if (activeIndex === sections.length - 1)
    nextButton.classList.add('container-hidden')
}

export function showSideMenu() {
  const sideMenu = document.getElementById('sidr')
  const sideMenuButton = document.getElementById('side-menu')

  $(sideMenuButton).sidr({
    displace: true,
    speed: 450,
    timing: 'ease-in-out'
  })

  sideMenu.classList.remove('container-hidden')

  // Revalida el estado al inicializar y después de cada apertura/cierre.
  // El segundo pase coincide con el final de la animación de Sidr.
  syncTerminalNavigation()

  sideMenuButton.addEventListener('click', () => {
    window.setTimeout(syncTerminalNavigation, 0)
    window.setTimeout(syncTerminalNavigation, 500)
  })

  document.getElementById('infografias-menu').onclick = () =>
    document.getElementById('infografias-submenu').classList.toggle('submenu-open')
}
